import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { AttendanceReportsRoutingModule } from './attendance-reports-routing.module';
import { AttendanceReportsComponent } from './attendance-reports.component';
import { ListAttendanceReportsComponent } from './components/list-attendance-reports.component';
import { EditAttendanceReportsComponent } from './components/edit-attendance-reports/edit-attendance-reports.component';
import { AuditPermissionsComponent } from './components/audit-permissions/audit-permissions.component';
import { EvaluationDetailModalComponent } from './components/evaluation-detail-modal/evaluation-detail-modal.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatIconModule,
    SharedModule,
    AttendanceReportsRoutingModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ],
  declarations: [
    AttendanceReportsComponent,
    ListAttendanceReportsComponent,
    EditAttendanceReportsComponent,
    AuditPermissionsComponent,
    EvaluationDetailModalComponent
  ]
})
export class AttendanceReportsModule { }